import React from 'react';
import { observer } from 'mobx-react';
import striptags from 'striptags';

import ImageView from 'lib/images/responsive-image-view';
import LinkView from 'lib/ui/link-view';
import Styled from 'styled';
import PostItemView from 'four-nets/ui/posts/post-item/post-item-view';

import { PostLink } from '../post-link';
import { CategoryLink } from '../category-link';
import defaultStyles from './blog-post-view.scss';

export class BlogPostViewModel {
    post: Post;
    link: PostLink;
    categoryLinks: CategoryLink[];

    constructor(post: Post) {
        this.post = post;
        this.link = new PostLink(post);
        this.categoryLinks = post.categories.map(category => new CategoryLink(category));
    }
}

@observer
@Styled(defaultStyles)
class BlogPostView extends React.Component {
    render() {
        const { maxi, blogPostViewModel, styles } = this.props;

        const { post, link, categoryLinks } = blogPostViewModel;

        let text = '';

        const split = striptags(post.excerpt.rendered).split(' ');

        for (let i = 0; i < split.length; i++) {
            text += `${split[i]} `;

            if (text.length > 160) {
                text += '...';
                break;
            }
        }

        const classNames = [styles.blogPost];
        if (maxi) {
            classNames.push(styles.maxi);
        }

        return (
            <div className={classNames.join(' ')}>
                {maxi && post.featuredMedia ? (
                    <LinkView link={link}>
                        <div className={styles.image}>
                            <ImageView
                                linkify={false}
                                aspectRatio={9 / 16}
                                aspectFill={true}
                                image={post.featuredMedia}
                                sizes={{
                                    xs: '100vw',
                                    md: 680,
                                }}
                            />
                        </div>
                    </LinkView>
                ) : null}
                <div className={styles.item}>
                    <PostItemView
                        img={
                            !maxi && post.featuredMedia ? (
                                <ImageView
                                    aspectRatio={9 / 16}
                                    aspectFill={true}
                                    image={post.featuredMedia}
                                    linkify={false}
                                    sizes={{
                                        xs: '100vw',
                                        md: 280,
                                    }}
                                />
                            ) : null
                        }
                        title={post.title.rendered}
                        link={link}
                        categoryLinks={categoryLinks}
                        text={text}
                        postDate={post.date}
                    />
                </div>
            </div>
        );
    }
}

export default BlogPostView;
